<template>
  <div class="channel">
    <el-select
      class="customer-select"
      filterable
      remote
      v-model="channel"
      placeholder="请选择推荐渠道"
      value-key="account_id"
      :remote-method="remoteMethod"
      :loading="loading"
      @change="onChannelSearch"
      style="width: 400px;max-width: 100%;"
      ref="select"
    >
      <el-option
        class="channel-select-option"
        v-for="(option, index) in optionList"
        :key="index"
        :label="option.showName"
        :value="option"
        :value-key="option.account_id"
      >
        <!-- <div class="channel-select-item">
          <div>
            <span>渠道名称：</span>
            <span>{{ option.account_name }}</span>
          </div>
          <div>
            <span>负责人：</span>
            <span>{{ option.user_name }}</span>
          </div>
        </div> -->
        <!-- <span>{{ option.user_sex_displayname }}</span> -->
      </el-option>
    </el-select>
  </div>
</template>

<script>
import mixins from "./mixins";
import cuotomerService from "@/apis/customer/index.js";
let originChanellList = [];

export default {
  name: "channel",
  mixins: [mixins],
  data() {
    return {
      answer: "",
      first: true,
      channel: null,
      optionList: [],
      loading: false,
    };
  },
  watch: {},
  async created() {
    // this.init();
    this.remoteMethod();
  },
  mounted() {
    Array.from(document.getElementsByClassName("el-select")).forEach((item) => {
      item.children[0].children[0].removeAttribute("readOnly");
      item.children[0].children[0].onblur = function () {
        let _this = this;
        setTimeout(() => {
          _this.removeAttribute("readOnly");
        }, 200);
      };
    });
  },
  methods: {
    async init() {
      await this.remoteMethod("散客");
      this.$nextTick(() => {
        this.channel = this.optionList[0];
        this.selectChange(this.channel);
      });
    },
    setInitialValue(value) {
      if (value) {
        this.channel = value;
        this.selectChange(value);
      }
    },
    reset() {
      this.channel = null;
      this.optionList = [];
      this.remoteMethod();
    },
    selectChange(value) {
      setTimeout(() => {
        document.querySelector("#_focus_input").focus();
      }, 100);
      this.change(value);
    },
    remoteMethod(query = "") {
      // if (!query) return;

      this.loading = true;
      const params = {
        filter: query,
      };
      this.lastIndex = this.lastIndex + 1;
      return cuotomerService.scrmAccounts(params).then((res) => {
        if (res && res.length > 0) {
          res.forEach((item) => {
            item.showName = `${item.account_name}(${item.user_name})`;
          });
          originChanellList = res;
          this.optionList = res;
        } else {
          this.optionList = [];
        }

        this.loading = false;
        return true;
      });
    },
    onChannelSearch(query = "") {
      console.log(originChanellList);

      // console.log(query);
      // if (!query) {
      //   this.optionList = originChanellList;
      // } else {
      //   this.optionList = originChanellList.filter((item) => {
      //     return item.showName.indexOf(query) !== -1;
      //   });
      // }
      this.selectChange(query);
    },
  },
};
</script>

<style lang="scss" scoped>
.channel-select-option {
  // display: flex;
  justify-content: space-between;
  overflow: auto;
  height: unset;
  line-height: 20px;
  padding: 10px 20px;
  span {
    white-space: pre-line;
  }
}

.channel-select-item {
  display: flex;
  flex-direction: column;
  & > div {
    display: flex;
    span:nth-child(1) {
      width: 70px;
      text-align: right;
    }
  }
}
</style>

<style lang="scss">
#_focus_input {
  position: fixed;
  top: -2000px;
}
.customer-select {
  .el-select-dropdown__item {
  }
}
.cuotomer-level {
  .el-form-item__content {
    display: flex;
    flex-direction: column;
  }
  .cuotomer-level-trip {
    color: red;
    font-size: 12px;
    line-height: 14px;
  }
}
</style>
